<script>
import CalendarHome from '@components/home/calendar-home.vue';
import CardDailyMeals from '@components/cards/card-daily-meals.vue';
import CardGoals from '@components/cards/card-goals.vue';
import moment from 'moment';
import CardWorkoutHome from '@components/cards/card-workout-home.vue';
import ChatButton from '@components/chat/chat-button.vue';
import { trainerComputed, authComputed, homeComputed } from '@state/helpers';

export default {
  components: {
    CalendarHome,
    CardDailyMeals,
    CardGoals,
    CardWorkoutHome,
    ChatButton,
  },
  data() {
    return {
      day: {
        aggregatedNutritionDigest: {
          macroNutritionDigest: {
            calories: {
              value: 1341,
            },
            carbs: {
              macroPercentage: 28,
              unit: 'g',
              value: 65,
            },
            fat: {
              macroPercentage: 40,
              unit: 'g',
              value: 91,
            },
            protein: {
              macroPercentage: 32,
              unit: 'g',
              value: 74,
            },
          },
        },
        dishes: [
          'https://picsum.photos/125/125/?image=58',
          'https://picsum.photos/125/125/?image=58',
          'https://picsum.photos/125/125/?image=58',
        ],
      },
      placeholder: require('@assets/images/placeholder-avatar.png'),
      backgroundLines: require('@assets/images/backgrounds/BackgroundLines.svg'),
      SFWebBackground: require('@assets/images/backgrounds/SFWebBackground.svg'),
      backgroundLinesTop: 0,
      lineChartHeight: 0,
    };
  },
  mounted() {
    const SFWebBackground = document.getElementsByClassName('section-wrapper');
    const backgroundLines = document.getElementsByClassName('background-lines');
    if (SFWebBackground && SFWebBackground.length > 0 && backgroundLines && backgroundLines.length > 0) {
      const backgroundLinesCenterPoint = backgroundLines[0].offsetTop / 2;
      backgroundLines[0].style.top = SFWebBackground[0].clientHeight - backgroundLinesCenterPoint + 'px';
    }
    if (document.getElementById('goals') && document.getElementById('goals').clientHeight > 0) {
      this.lineChartHeight = document.getElementById('goals').clientHeight - 170;
    } else {
      this.lineChartHeight = 200;
    }
  },
  computed: {
    ...authComputed,
    ...trainerComputed,
    ...homeComputed,
    currentWeekNumber() {
      return this.homeOverview && this.homeOverview.weekNumber;
    },
    currentWeek() {
      return (
        this.progressDetails &&
        this.progressDetails.weeks &&
        this.progressDetails.weeks.length > 0 &&
        this.progressDetails.weeks.find((week) => week.weekNumber === this.currentWeekNumber)
      );
    },
    workoutOptions() {
      return this.homeOverview && this.homeOverview.workoutOptions;
    },

    workout() {
      const todaysDate = this.selectedDay && this.selectedDay.date ? moment(this.selectedDay.date) : false;
      return (
        this.selectedDay &&
        this.selectedDay.workouts &&
        this.selectedDay.workouts.length > 0 &&
        this.selectedDay.workouts[0] &&
        this.workoutOptions &&
        this.workoutOptions.length > 0 &&
        this.selectedDay &&
        todaysDate &&
        this.workoutOptions.find((workout) => moment(workout.date).isSame(todaysDate, 'day'))
      );
    },
    greeting() {
      const today = new Date();
      const curHr = today.getHours();
      const firstName =
        this.currentUser && this.currentUser.user && this.currentUser.user.profile ? this.currentUser.user.profile.firstName : '';
      if (curHr < 12) {
        return 'Good Morning, ' + firstName + '!';
      } else if (curHr < 18) {
        return 'Good Afternoon, ' + firstName + '!';
      } else {
        return 'Good Evening, ' + firstName + '!';
      }
    },
  },
};
</script>

<template>
  <b-container>
    <div class="background-image">
      <img :src="SFWebBackground" class="sf-background" />
      <img svg-inline :src="backgroundLines" class="background-lines" />
    </div>
    <h1 class="greeting" v-if="homeOverview.todaysTrainerNote || homeOverview.isProgramEmpty">{{ greeting }}</h1>
    <div class="section-wrapper">
      <b-row
        class="calendar-workout-container"
        :style="{ 'margin-top': !homeOverview.todaysTrainerNote && !homeOverview.isProgramEmpty ? '40px' : '0' }"
      >
        <div class="col-6">
          <CalendarHome :currentWeek="currentWeek" :workoutOptions="workoutOptions" :greeting="greeting" />
        </div>
        <div class="col-6">
          <CardWorkoutHome :workout="workout" />
        </div>
      </b-row>
    </div>

    <div class="section-wrapper" v-if="day">
      <b-row>
        <b-col sm="12">
          <CardDailyMeals :day="day" />
        </b-col>
      </b-row>
    </div>

    <div class="section-wrapper">
      <b-row>
        <b-col sm="12" id="goals">
          <CardGoals :goals="homeOverview.goalCharts.weight" :lineChartHeight="lineChartHeight" />
        </b-col>
      </b-row>
    </div>

    <ChatButton />
  </b-container>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.container {
  max-width: unset;
  padding-left: 5vw;
  padding-right: 5vw;

  .greeting {
    @include calc-font-size(3);

    color: white;
    font-family: $proxima-nova;
    font-weight: 550;
    letter-spacing: 0.01em;
    padding-top: 22px;
  }

  .section-wrapper {
    margin-bottom: 4rem;
  }

  .calendar-workout-container {
    margin-bottom: 40px;
  }

  .background-image {
    background-repeat: no-repeat;
    background-size: cover;
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;

    .sf-background {
      max-height: auto;
      object-fit: cover;
      width: 100vw;
    }

    .background-lines {
      left: 0;
      max-height: auto;
      object-fit: cover;
      position: absolute;
      right: 0;
      width: 100vw;
    }
  }

  .chat-button {
    ::v-deep .btn-primary {
      svg {
        height: 100%;
        width: 100%;
      }
    }

    ::v-deep .messages-container {
      height: 100rem;
      max-height: 60vh;

      .messages-list {
        .messages-wrapper {
          height: 100rem;
          max-height: calc(60vh - 10.8rem);
        }
      }
    }
  }
}
</style>
